// src/components/auth/VerifyEmail.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axiosConfig from '../../api/axiosConfig';
import { STORAGE_KEYS } from '../../utils/constants';

const VerifyEmail = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [status, setStatus] = useState('loading'); // loading | success | error

    useEffect(() => {
        const verify = async () => {
            try {
                const res = await axiosConfig.get(`/auth/verify-email/${token}`);
                if (res.data.data?.token) {
                    localStorage.setItem(STORAGE_KEYS.TOKEN, res.data.data.token);
                    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, res.data.data.refreshToken || '');
                }
                setStatus('success');
                setTimeout(() => navigate('/dashboard'), 2500);
            } catch {
                setStatus('error');
            }
        };
        if (token) verify();
    }, [token, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950">
            <div className="bg-white/95 rounded-2xl shadow-2xl p-10 max-w-md w-full mx-4 text-center">
                {status === 'loading' && (
                    <>
                        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                        <h2 className="text-xl font-bold text-gray-900">{t('auth.emailVerifying')}</h2>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <div className="text-5xl mb-4">✅</div>
                        <h2 className="text-xl font-bold text-gray-900 mb-2">{t('auth.emailVerified')}</h2>
                        <p className="text-gray-500 text-sm">{t('auth.redirectingDashboard')}</p>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <div className="text-5xl mb-4">⚠️</div>
                        <h2 className="text-xl font-bold text-gray-900 mb-2">{t('auth.emailLinkInvalid')}</h2>
                        <p className="text-gray-500 text-sm mb-6">{t('auth.emailLinkExpired')}</p>
                        <button
                            onClick={() => navigate('/dashboard')}
                            className="w-full py-2.5 bg-blue-600 text-white rounded-xl font-semibold text-sm hover:bg-blue-700 transition"
                        >
                            {t('nav.dashboard')}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default VerifyEmail;
